import React, { createContext, useState, useEffect, useMemo } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // 1. State to hold the current theme. Default to 'light'.
  // We check localStorage for a saved theme.
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    // You can also check for user's system preference here if you want
    // const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return savedTheme || 'light';
  });

  // 2. Effect to apply the theme to the body and save to localStorage
  useEffect(() => {
    // Add the data-theme attribute to the body
    document.body.setAttribute('data-theme', theme);
    // Save the user's preference to localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  // 3. Function to toggle the theme
  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // 4. Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(() => ({
    theme,
    toggleTheme
  }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
